module.exports = __webpack_public_path__ + "static/media/Why Our Save the Dat.1b47c86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/Why Our Save the Dat.png
// module id = 987
// module chunks = 40